// extracted by mini-css-extract-plugin
module.exports = {"whatsappButton":"whatsapp-button_whatsappButton__1veq1"};